console.log('✅ category-card.js loaded successfully!');

export async function buildComponentCategoryCard(link, imageSource, name, categoryCardType) {
  // console.log(`🔄 Building Component: FeaturedHomePageCategoryCard - Category Name: ${name}`);

  try {
    //// If the category card type is "Lazy", show the loading skeleton
    //if (categoryCardType === "Lazy") {
    //    return `
    //        <div class="FeaturedHomePageCategoryCard" role="img" aria-label="${name}">
    //            <div class="grid-blog-home-featured-top-card my-fake-image-height-275">
    //                <div class="my-site-lazy-loading-card-darker">
    //                    <div class="my-site-lazy-loading-card-movement"></div>
    //                </div>
    //            </div>
    //        </div>
    //    `;
    //}

    let html = '';

    // Check if loading state is enabled
    if (categoryCardType === 'Lazy') {
      html = `
                <div class="FeaturedHomePageCategoryCard" role="img" aria-label="${name}">
                   <div class="grid-blog-home-featured-top-card my-fake-image-height-275">
                       <div class="my-site-lazy-loading-card-darker">
                            <div class="my-site-lazy-loading-card-movement"></div>
                        </div>
                    </div>
                </div>
            `;
    } else {
      // Build the category card HTML
      html = `
            <div class="FeaturedHomePageCategoryCard" role="img" aria-label="${name}">
                <a href="${link}">
                    <img width="225" height="225" class="img" src="${imageSource}" alt="${name}" loading="lazy" />
                    <div class="category-box-down">${name}</div>
                </a>
            </div>
        `;
    }

    //  console.log("✅ FeaturedHomePageCategoryCard built successfully.");

    // Register event listeners (if any needed in the future)
    // registerEventListenerToAttach(attachEventListenersFeaturedHomePageCategoryCard);

    return html;
  } catch (err) {
    console.error('❌ Error building FeaturedHomePageCategoryCard:', err);
    return '<div>Error loading category card</div>';
  }
}

/**
 * Attaches event listeners to the Featured Home Page Category Card component
 */
function attachEventListenersFeaturedHomePageCategoryCard() {
  try {
    console.log('✅ FeaturedHomePageCategoryCard event listeners attached.');
    // Placeholder for future event listeners if needed
  } catch (error) {
    console.error('❌ Error attaching event listeners to FeaturedHomePageCategoryCard:', error);
  }
}
